<template>
  <b-container>
    <ObjectListTabs>
      <template slot-scope="{}">
        <b-nav-item :to="{name: 'artist-video-edit', params: {id: video.id}}" v-if="video.id">Edit Video</b-nav-item>
        <b-nav-item :to="{name: 'artist-video-manage-comments', params: {id: video.id}}" v-if="video.id">Manage Comments</b-nav-item>
        <b-nav-item :to="{name: 'artist-video-create'}" v-if="!video.id">Upload Video</b-nav-item>
      </template>
      <template slot="cmd" slot-scope="{}">
        <router-link class="cancel-link" :to="cancelLink">cancel</router-link>
      </template>
      <template slot="mobileCmd" slot-scope="{}">
        <b-nav-item :to="cancelLink">cancel</b-nav-item>
      </template>
    </ObjectListTabs>

    <b-row class="command-row" align-v="center">
      <b-col>
        <h1 v-if="video.id">
          {{ video.title }}
          <small v-if="video.is_taken_down" class="takedown">
            (taken down for <em>Terms of Use</em> violation)
          </small>
        </h1>
        <h1 v-else>
          Add New Video
        </h1>
      </b-col>
      <b-col cols="*" v-if="!video.is_taken_down">
        <LinkButton v-b-modal.confirmDelete :u="true" v-if="video.id">Delete video</LinkButton>
        <b-button class="btn-rainbow" @click="saveVideo">Save</b-button>
      </b-col>
    </b-row>

    <b-row class="video-details first">
      <b-col class="dropzone" v-if="!hasVideo && !video.is_uploading">
        <div class="big-info">
          Select a video to upload
        </div>
        <b-button class="btn-rainbow" @click="selectVideoFile">click here to browse</b-button>
        <input type="file" id="videofile" ref="fileInput" @change="onVideoFileSelected">
        <div lass="info">
          Formats accepted: .mp4, .mov, .mkv
        </div>
      </b-col>

      <b-col class="dropzone" v-if="!hasVideo && video.is_uploading">
        <div class="processing">
          <font-awesome-icon icon="spinner" size="lg" spin />
          <br />
          Processing uploaded video ...
        </div>
      </b-col>

      <b-col v-if="hasVideo" class="videoplayer">
        <video v-if="videoFileUrl" :src="videoFileUrl" controls=true ref="videoPreview" />
        <div v-if="video.dacast_content_id" ref="dacastPlayerWrapper"></div>
        <b-button variant="danger" size="xs" class="remove" @click="removeVideoFile">
          <font-awesome-icon icon="times" />
        </b-button>
      </b-col>
      <b-col>
        <b-form-group id="titleGroup"
                      label="Video Title"
                      label-for="title"
                      :invalidFeedback="errorTitle"
                      :state="stateTitle">
          <b-form-input type="text" required placeholder="Title of the video" v-model="video.title" :state="stateTitle" />
        </b-form-group>

        <b-form-checkbox v-model="video.is_explicit">
            Explicit Content
            <small>
              Strong language or age inappropriate material
            </small>
        </b-form-checkbox>

      </b-col>
    </b-row>

    <b-row class="video-details">
      <b-col>
        <b-form-group id="videoTypeGroup"
                      label="Video Type"
                      label-for="videoType">
          <b-form-select v-model="video.video_type" id="videoType" :options="videoTypes" />
        </b-form-group>

      </b-col>
      <b-col>
        <b-form-group id="visibilityGroup"
                      label="Visibility"
                      label-for="visibility"
                      :invalidFeedback="errorVideoVisibility"
                      :state="stateVideoVisibility"
                      :description="hasProcessedVideo ? '' : 'New videos must be saved as draft first'">
          <b-form-select v-model="video.video_visibility"
                         id="visibility"
                         :options="videoVisibilities"
                         :state="stateVideoVisibility"
                         :disabled="!hasProcessedVideo" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="video-details">
      <b-col>
        <b-form-group label="Genre (up to 3)"
                      label-for="username">
          <multiselect v-model="video.genres"
                       :searchable="false"
                       :multiple="true"
                       :max="3"
                       :showNoResults="false"
                       :options="genres">
            <template slot="maxElements">
              Maximum of 3 options
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Mood (up to 2)"
                      label-for="username">
          <multiselect v-model="video.moods"
                       :searchable="false"
                       :multiple="true"
                       :max="2"
                       :showNoResults="false"
                       :options="moods">
            <template slot="maxElements">
              Maximum of 2 options
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="video-details">
      <b-col>
        <b-form-group label="Instruments (up to 5)"
                      label-for="username">
          <multiselect v-model="video.instruments"
                       :searchable="false"
                       :multiple="true"
                       :max="5"
                       :showNoResults="false"
                       :options="instruments">
            <template slot="maxElements">
              Maximum of 5 options
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="video-details">
      <b-col>
        Credit other contributors
        <small>(give a shout out to other artists you collaborated with or anyone else who helped
          behind the scenes)
        </small>
        <UserList v-model="contributors"
                  :withRoles="true"
                  :canAdd="true"
                  :canRemove="true"
                  addLabel="Add contributor"
                  handleLabel="Contributor handle"
                  roleLable="Contributor type"
                  :requireUser="true">
        </UserList>
      </b-col>
    </b-row>

    <b-row class="video-details">
      <b-col class="audio-col">
        <b-form-group label="Audio file available for download"
                      label-for="audiofile"
                      description="Supported audio file formats: AAC (256 Kbps recommended), WAV, FLAC, and AIFF">
          <b-form-file v-model="audioFile" id="audiofile" placeholder="Choose a file..." v-if="!hasAudio"></b-form-file>
          <audio :src="audioFileUrl" v-if="hasAudio" controls=true />
        </b-form-group>
        <div v-if="hasAudio">
          <LinkButton v-if="canRemoveAudio" @click="removeAudio" :u="true">remove audio file</LinkButton>
          <a v-else id="remove-audio-popover" href="javascript:false" class="text-muted">remove audio file</a>
          <b-popover
            target="remove-audio-popover"
            placement="bottom"
            triggers="hover"
            content="cannot remove file because part of an album and/or already downloaded"
          ></b-popover>
        </div>
      </b-col>
      <b-col cols="*">
        <b-form-group label="Sale Price (USD)"
                      description="Free, or minimum $0.50"
                      label-for="trackPrice"
                      :invalidFeedback="errorTrackPrice"
                      :state="stateTrackPrice"
                      class="short">
          <b-form-input v-model="video.track_price" id="trackPrice" type="text" placeholder="Example: 2.50" :state="stateTrackPrice" />
        </b-form-group>
        <b-form-checkbox v-model="video.can_pay_more" size="sm">
            Let fans back you more, and they might pay a little extra
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="video-details last">
      <b-col>
        <b-form-group id="usernameGroup"
                      label="Lyrics"
                      label-for="username">
          <b-form-textarea
                           v-model="video.lyrics"
                           placeholder=""
                           :rows="5">
          </b-form-textarea>
        </b-form-group>

      </b-col>
    </b-row>

    <b-row class="command-row bottom" align-v="center" v-if="!video.is_taken_down">
      <b-col>
        <LinkButton v-b-modal.confirmDelete :u="true" v-if="video.id">Delete video</LinkButton>
        <b-button class="btn-rainbow" @click="saveVideo" v-if="video.id">Save</b-button>
      </b-col>
    </b-row>

    <b-modal id="noAudioModal"
             ref="noAudioModal"
             title="Publish Video"
             @ok="saveWithoutAudio"
             centered>
      <div class="content">
        <p>
          Don’t miss out on extra earning opportunities by uploading an audio file.
        </p>
        <p>
          Do you want to publish this video anyway?
        </p>
      </div>
    </b-modal>

    <b-modal id="confirmDelete"
             ref="confirmDelete"
             title="Delete video"
             @ok="deleteVideo"
             centered>
      <div class="content">
        <p>
          Are you sure you want to delete this video?
        </p>
      </div>
    </b-modal>

    <b-modal id="videoSelectedInfo"
             ref="videoSelectedInfo"
             title="Video selected"
             :ok-only="true"
             centered>
      <div class="content">
        <p>
          Once all the required (and desired) information has been filled out on this form, press “Save” to start the video upload process. Processing times will vary.
        </p>
        <p>
          To access videos that have been completely processed, go to the “Drafts” tab (under “Videos”), click on the desired thumbnail, then select whether to publish the video as either public or private.
        </p>
        <p>
          Some videos shot with a mobile phone or tablet may be incorrectly displayed (rotated). Before publishing video, please check that your uploaded video is correctly displayed.
        </p>
        <p>
          If video plays sideways or otherwise appears incorrectly, please use a desktop video editor to adjust the format. For optimal results, we recommend converting to a 16:9 (width/height) aspect ratio, 25 (or 30) FPS, and H.264 video.
        </p>
      </div>
    </b-modal>

    <b-modal id="videoSelectedError"
             ref="videoSelectedError"
             title="Unsupported video"
             :ok-only="true"
             centered>
      <div class="content">
        <p>
          The following error was encountered:
        </p>
        <ul v-if="videoError === 'unsupported-video'">
          <li>Video format <u>not supported</u>.</li>
          <li>Video formats accepted are: .mp4, .mov, or .mkv.</li>
        </ul>
        <ul v-if="videoError === 'video-too-short'">
          <li>Video length is <u>too short</u>.</li>
          <li>Duration of video must be at least 10 seconds.</li>
        </ul>
        <ul v-if="videoError === 'video-too-small'">
          <li>Video resolution is <u>too small</u>.</li>
          <li>Minimum video resolution is 320x240.</li>
        </ul>
        <ul v-if="videoError === 'video-too-large'">
          <li>Video resolution is <u>too large</u>.</li>
          <li>Maximum video resolution is 1920x1080.</li>
        </ul>
        <p v-if="videoError !== 'video-too-short'">
          To convert the video to a supported format and/or size, use a video converter &mdash;
          we recommend trying <a target="_blank" href="https://handbrake.fr">Handbrake</a> (free).
        </p>
      </div>
    </b-modal>

    <b-modal id="videoPublishedInfo"
             ref="videoPublishedInfo"
             title="Video published"
             :ok-only="true"
             @ok="onClosePublishedInfo"
             centered>
      <div class="content">
        <p>
          Have you double checked to make sure your video has been formatted correctly?
        </p>

        <p>
          If video plays sideways or otherwise appears incorrectly, please use a desktop video editor to adjust the format. For optimal results, we recommend converting to a 16:9 (width/height) aspect ratio, 25 (or 30) FPS, and H.264 video.
        </p>
      </div>
    </b-modal>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .cancel-link {
    color: $white;
  }

  .command-row {
    margin-bottom: 1em;

    a {
      color: $white;
      text-decoration: underline;
    }

    .btn-rainbow {
      margin-left: 2em;
      padding-left: 2em;
      padding-right: 2em;
    }

    h1 {
      font-size: 1.5em;

      .takedown {
        color: $tomato;
      }
    }

    &.bottom {
      margin-top: 1em;
      text-align: right;
    }
  }

  .video-details {
    margin: 0 -30px;
    padding: 1em 0 1em 1em;

    &.first {
      background-image: linear-gradient(to bottom, #1e1f36, rgba(0, 0, 0, 0));
    }

    &.last {
      box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.5);
    }

    .dropzone {
      min-height: 15em;
      display: flex;
      flex-direction: column;
      background-image: url('/static/img/wireframe.svg');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      justify-content: center;
      align-items: center;

      .processing {
        text-align: center;
        line-height: 2em;
      }

      .big-info {
        margin-bottom: 1em;
      }

      .info {
        margin-top: 1em;
        font-size: 0.8em;
        color: $steel;
      }
    }

    #dacast-video-preview {
      width: 466px;
      height: 240px;
    }

    .videoplayer {
      position: relative;

      video {
        width: 100%;
      }

      .remove {
        position: absolute;
        top: 15px;
        left: 30px;
      }
    }

    small {
      color: $steel;
    }
  }

  #videofile {
    display: none;
  }

  /deep/ .multiselect {
    .multiselect__tag {
      color: $white;
      background-color: $darkish-pink-three;

      .multiselect__tag-icon:after {
        color: white;

      }

      .multiselect__tag-icon:focus,
      .multiselect__tag-icon:hover,
      .multiselect__tag-icon:hover:after {
        background-color: $darkish-pink;
      }
    }

    .multiselect__option--highlight,
    .multiselect__option--highlight:after {
      background-color: $darkish-pink;
    }
  }

  .audio-col {
    z-index: 0;
  }

  .short input.form-control {
    width: 8em;
  }

</style>

<script>
import Vue from 'vue'
import clone from 'lodash/clone'

import { mapActions } from 'vuex'

import Multiselect from 'vue-multiselect'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import LinkButton from '@/components/widgets/LinkButton'
import UserList from '@/components/widgets/UserList'
import ObjectListTabs from '@/components/widgets/ObjectListTabs'

import themeObject from '@/components/widgets/dacastPlayerTheme'

import { genres, moods, instruments } from '@/store/modules/tag'
import { videoVisibilities, videoTypes } from '@/store/modules/song'
import { parseErrors, mapErrorStates } from '@/store/helpers'

export default {
  name: 'EditVideo',
  components: {
    FontAwesomeIcon,
    Multiselect,
    LinkButton,
    UserList,
    ObjectListTabs
  },
  data () {
    return {
      errors: {},
      genres: genres,
      moods: moods,
      instruments: instruments,
      contributors: [],
      contributorDropdownVisible: false,
      contributorHandle: '',
      contributorRole: '',
      videoTypes: videoTypes,
      videoVisibilities: videoVisibilities,
      videoFile: null,
      videoError: null,
      audioFile: null,
      removedPublishedVideoFile: false,
      removedPublishedAudioFile: false,
      dacastPlayer: null,
      uploadProgress: null,
      publishWithoutAudio: false,
      wasPublished: false,
      video: {
        video_visibility: 'draft',
        genres: [],
        moods: [],
        instruments: [],
        contributors: {}
      }
    }
  },
  computed: {
    hasVideo () {
      return this.videoFile || this.video.dacast_content_id
    },
    hasProcessedVideo () {
      return !!this.video.dacast_content_id
    },
    hasAudio () {
      return this.audioFile || this.video.audio_track
    },
    videoFileUrl () {
      if (!this.videoFile) return null
      return URL.createObjectURL(this.videoFile)
    },
    audioFileUrl () {
      if (this.video.audio_track) return this.video.audio_track
      if (this.audioFile) return URL.createObjectURL(this.audioFile)
      return null
    },
    cancelLink () {
      if (this.video && this.video.id) {
        return {name: 'artist-video-list', params: {visibility: this.video.video_visibility}}
      } else {
        return {name: 'artist-video-list', params: {visibility: 'draft'}}
      }
    },
    canRemoveAudio () {
      if (this.video.is_purchased || this.video.in_album) return false
      return true
    },
    ...mapErrorStates(['title', 'track_price', 'video_visibility'])
  },
  created () {
    this.initPage()
  },
  mounted () {
    Vue.nextTick(this.initDacastPlayer)
  },
  beforeDestroy () {
    if (this.dacastPlayer) {
      try { this.dacastPlayer.dispose() } catch (e) {}
      this.dacastPlayer = null
    }
  },
  watch: {
    '$route': 'initPage'
  },
  methods: {
    initPage () {
      if (this.dacastPlayer) {
        try { this.dacastPlayer.dispose() } catch (e) {}
        this.dacastPlayer = null
      }

      const artist = this.$store.getters['artist/artist']

      if (!artist || !artist.id) {
        this.$router.push({name: 'artist-dashboard'})
        return
      }

      if (!this.$route.params.id) return

      this.$store
        .dispatch('song/getOwnSong', {id: this.$route.params.id})
        .then(video => {
          if (video.artist.id !== artist.id) {
            this.$router.push({name: 'artist-dashboard'})
            return
          }

          this.parseVideo(video)
          this.wasPublished = video.video_visibility !== 'draft'
          if (this.video.is_uploading) {
            setTimeout(this.checkVideoStatus, 5000)
          }

          Vue.nextTick(this.initDacastPlayer)
        })
    },
    parseVideo (video) {
      video.genres = []
      video.moods = []
      video.instruments = []

      for (let tag of video.tags) {
        if (genres.indexOf(tag) !== -1) {
          video.genres.push(tag)
        }
        if (moods.indexOf(tag) !== -1) {
          video.moods.push(tag)
        }
        if (instruments.indexOf(tag) !== -1) {
          video.instruments.push(tag)
        }
      }

      this.contributors = []
      for (let c in video.song_credits) {
        this.contributors.push({
          handle: video.song_credits[c],
          user: video.song_credits_expanded[c],
          role: c
        })
      }

      this.video = video
    },
    checkVideoStatus () {
      if (!this.video.id || !this.video.is_uploading) return

      this.$store
        .dispatch('song/getOwnSong', {id: this.video.id})
        .then(video => {
          if (video.is_uploading) {
            // still not done, retry in 5s
            setTimeout(this.checkVideoStatus, 5000)
          } else {
            // pick up video content data but don't overwrite something the user may currently be working on
            this.video.dacast_content_id = video.dacast_content_id
            this.video.dacast_video_details = video.dacast_video_details
            this.videoFile = false
            this.removedPublishedVideoFile = false

            Vue.nextTick(this.initDacastPlayer)
          }
        })
    },
    selectVideoFile () {
      this.$refs.fileInput.click()
    },
    onVideoFileSelected () {
      const fileInput = this.$refs.fileInput
      if (!fileInput) return

      if (fileInput.files.length !== 1) return
      this.videoFile = fileInput.files[0]
      fileInput.value = ''
      this.videoError = null

      const self = this

      function verifyVideo () {
        const video = self.$refs.videoPreview

        if (!video) {
          window.setTimeout(verifyVideo, 100)
          return
        }

        if (video.error) {
          console.error('Video file not recognized', video.error)
          self.videoFile = null
          self.videoError = 'unsupported-video'
          self.$refs.videoSelectedError.show()
          return
        }

        if (video.readyState === 0) { // HAVE_NOTHING
          window.setTimeout(verifyVideo, 500)
          return
        }

        if (video.duration < 10) {
          self.videoError = 'video-too-short'
          self.videoFile = null
          self.$refs.videoSelectedError.show()
          return
        }

        if (video.videoWidth < 320 || video.videoHeight < 240) {
          self.videoError = 'video-too-small'
          self.videoFile = null
          self.$refs.videoSelectedError.show()
          return
        }

        if (video.videoWidth > 1920 || video.videoHeight > 1080) {
          self.videoError = 'video-too-large'
          self.videoFile = null
          self.$refs.videoSelectedError.show()
          return
        }

        self.videoError = null
        self.duration = video.duration

        self.$refs.videoSelectedInfo.show()
      }

      Vue.nextTick(verifyVideo)
    },
    removeVideoFile () {
      this.videoFile = null

      if (this.video.dacast_content_id) {
        this.video.dacast_video_details = {}
        this.video.dacast_content_id = null
        this.removedPublishedVideoFile = true
      }

      if (this.dacastPlayer) {
        this.dacastPlayer.dispose()
        this.dacastPlayer = null
      }
    },
    removeAudio () {
      this.audioFile = null
      this.video.audio_track = null
      this.removedPublishedAudioFile = true
    },
    saveWithoutAudio () {
      this.publishWithoutAudio = true
      this.saveVideo()
    },
    async saveVideo () {
      if (this.video.is_taken_down) {
        this.$store.dispatch('flash/showMessage', {message: 'Can\'t modify video that was taken down', type: 'error'})
        return
      }

      if ((this.video.video_visibility !== 'draft') && !this.hasAudio && !this.publishWithoutAudio) {
        this.$refs.noAudioModal.show()
        return
      }

      this.video.tags = this.video.genres.concat(this.video.moods, this.video.instruments)

      this.video.song_credits = {}
      for (let c of this.contributors) {
        this.video.song_credits[c.role] = c.handle
      }

      this.showModal('Saving video metadata ...')
      let isCreate = !this.video.id
      let resp

      // If this is a new video, first save it, then try to upload audio track and video content
      if (isCreate) {
        let data = clone(this.video)
        let requestedVisibility = this.video.video_visibility
        data.video_visibility = 'draft'

        try {
          resp = await this.$store.dispatch('song/createSong', data)
        } catch (e) {
          this.$store.dispatch('flash/showMessage', {message: 'Error creating video', type: 'error'})
          this.hideModal()
          if (e.response && e.response.data) {
            this.errors = parseErrors(e.response.data)
          }
          return
        }

        // parse will reset video visibility to draft so we have to change it back
        this.parseVideo(resp)
        this.video.video_visibility = requestedVisibility
      }

      if (this.removedPublishedAudioFile) {
        this.showModal('Removing old audio track ...')
        try {
          await this.$store.dispatch('song/deleteAudioTrack', { id: this.video.id })
        } catch (e) {
          let msg = 'Error removing audio'
          let responseData = e.response && e.response.data
          if (responseData.detail) msg = `Error: ${responseData.detail}`
          this.initPage()
          this.$store.dispatch('flash/showMessage', {message: msg, type: 'error'})
          this.hideModal()
          this.removedPublishedAudioFile = false
          return
        }
        this.removedPublishedAudioFile = false
      }

      if (this.audioFile) {
        this.showModal('Uploading audio track ...')
        try {
          await this.$store.dispatch('song/setAudioTrack', { id: this.video.id, file: this.audioFile })
        } catch (e) {
          this.$store.dispatch('flash/showMessage', {message: 'Unsupported audio file format', type: 'error'})
          this.hideModal()
          return
        }
      }

      if (this.removedPublishedVideoFile) {
        this.showModal('Removing old video content ...')
        await this.$store.dispatch('song/deleteVideo', { id: this.video.id })
        this.removedPublishedVideoFile = false
      }

      if (this.videoFile) {
        this.showModal('Uploading video content ...')
        try {
          await this.$store.dispatch('song/uploadVideo', { id: this.video.id, file: this.videoFile })
        } catch (e) {
          this.$store.dispatch('flash/showMessage', {message: 'Unsupported video file format or network error', type: 'error'})
          this.hideModal()
          return
        }
      }

      try {
        resp = await this.$store.dispatch('song/updateSong', this.video)
      } catch (e) {
        let msg = 'Error creating video'
        let responseData = e.response && e.response.data
        if (responseData.detail) msg = `Error: ${responseData.detail}`
        this.$store.dispatch('flash/showMessage', {message: msg, type: 'error'})
        this.hideModal()
        if (responseData) {
          this.errors = parseErrors(responseData)
        }
        return
      }

      if (isCreate) {
        this.$store.dispatch('flash/showMessage', {message: 'New video created'})
      } else {
        this.$store.dispatch('flash/showMessage', {message: 'Video updated'})
      }

      this.hideModal()
      if ((this.video.video_visibility !== 'draft') && !this.video.wasPublished) {
        this.$refs.videoPublishedInfo.show()
      } else {
        this.$router.push({name: 'artist-video-list', params: {visibility: this.video.video_visibility}})
      }
    },
    onClosePublishedInfo () {
      this.$router.push({name: 'artist-video-list', params: {visibility: this.video.video_visibility}})
    },
    async deleteVideo () {
      if (!this.video.id) return

      try {
        await this.$store.dispatch('song/deleteVideo', { id: this.video.id })
      } catch (e) {
        let msg = 'Can\'t delete video'
        if (e.response && e.response.data && e.response.data.detail) {
          msg = 'Video cannot be deleted - ' + e.response.data.detail
        }
        this.$store.dispatch('flash/showMessage', {message: msg, type: 'error'})
        return
      }

      this.$store.dispatch('flash/showMessage', {message: 'Deleted video'})
      this.$router.push({name: 'artist-video-list', params: {visibility: 'public'}})
    },
    initDacastPlayer () {
      if (this.video.dacast_content_id && this.$refs.dacastPlayerWrapper) {
        this.dacastPlayer = window.dacast(this.video.dacast_content_id, this.$refs.dacastPlayerWrapper, {
          player: 'theo',
          width: '426',
          height: '240',
          theme: themeObject,
          options: {
            autoplay: false
          }
        })
      }
    },
    ...mapActions('flash', ['showModal', 'hideModal'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/EditVideo.vue